import React, { Fragment } from "react";
import { noop } from "lodash";

import RegistrationHeaderMask from "../../_static/Masks/registrationHeader";
import { ParallelogramProgressBarAtom } from "../../_atom/ParalelogramProgressBar";
import {
  SectionContainer,
  Title,
  Description,
  RowContainer,
  Button,
  HeaderMaskWrapper
} from "./styled-components";

const WelcomeHeaderRegistrationMolecule = (props) => {
  const {
    title,
    description,
    hasPromo,
    handleTermsAndDetails,
    isLoading,
    welcomeHeaderTitleRef,
    promoCTAText
  } = props;

  return (
    <SectionContainer>
      {isLoading ? (
        <HeaderMaskWrapper>
          <RegistrationHeaderMask />
        </HeaderMaskWrapper>
      ) : (
        <Fragment>
          <ParallelogramProgressBarAtom
            qaLabel="registration-parallelogram"
            marginBottom={hasPromo ? 24 : 12}
            isShortened={false}
            type="GREEN"
            items={[
              {
                text: "Account",
                width: 80,
                marginRight: 2,
                isSelected: true
              },
              {
                text: "Address",
                width: 80,
                marginRight: 2,
                isSelected: false
              },
              {
                text: "Verify",
                width: 80,
                isSelected: false
              }
            ]}
          />
          <RowContainer>
            <Title data-qa-label="welcome-title" ref={welcomeHeaderTitleRef}>
              {title}
            </Title>
          </RowContainer>
          <RowContainer>
            <Description
              hasPromo={hasPromo}
              data-qa-label="welcome-description"
            >
              {description}
            </Description>
          </RowContainer>
          {hasPromo && (
            <RowContainer alignCenter>
              <Button onClick={handleTermsAndDetails}>{promoCTAText}</Button>
            </RowContainer>
          )}
        </Fragment>
      )}
    </SectionContainer>
  );
};

WelcomeHeaderRegistrationMolecule.defaultProps = {
  title: "",
  description: "",
  handleTermsAndDetails: noop,
  promoCTAText: ""
};

export default WelcomeHeaderRegistrationMolecule;
